// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"721":"bc919c2f","787":"bf32509e","957":"ae17dca9","970":"72c3dfef"}[chunkId] + ".chunk.js";
};